import React from 'react'
import { Error } from '../../components'

export const PageNotFound = () => {
    const message = '404 Error. The page you are looking for does not exist.'
    return <Error error={message} />
}
